import { FC } from "react";

import { BaseFooter } from "./BaseFooter";

import { withActiveAv } from "components/av/AvSubsystemLoader";
import { ScreenshareOptions } from "components/av/ScreenshareOptions";
import { PresentationOptions } from "components/materials/presentation/PresentationOptions";
import { PageType } from "components/server-types";
import { useAppSelector } from "store/index";
import { selectIsInBreakout } from "store/selectors/breakouts";
import { selectIsScreensharingOn } from "store/selectors/virtual-classes";
import { useAv } from "utils/av";

const LazyBreakoutsBanner = withActiveAv(
  () => import("components/footer/controls/BreakoutsBanner"),
);

interface RecordingAgentMainFooterProps {
  selectedPage: PageType;
}

export const RecordingAgentMainFooter: FC<RecordingAgentMainFooterProps> = ({ selectedPage }) => {
  const { isInVirtualClass, isVirtualClassActive } = useAv();
  const isInBreakout = useAppSelector(selectIsInBreakout);
  const isScreensharingOn = useAppSelector(selectIsScreensharingOn);

  return (
    <BaseFooter darkMode>
      <div className="flex h-full w-full items-center justify-between">
        <div className="flex h-full w-full items-center justify-center gap-2">
          {isVirtualClassActive && isInVirtualClass && isInBreakout && <LazyBreakoutsBanner />}
          {isScreensharingOn ? (
            <ScreenshareOptions />
          ) : (
            <PresentationOptions selectedPage={selectedPage} />
          )}
        </div>
      </div>
    </BaseFooter>
  );
};
